import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { createHorizonErrorRoutes, createHorizonLoginRoutes } from '@bayclubs/horizon';

const routes: Routes = [
    ...createHorizonLoginRoutes(),
    { path: '', loadChildren: () => import('./core/core.module').then(m => m.CoreModule) },
    {
        path: 'observability',
        loadComponent: () => import('@bayclubs/horizon').then(m => m.HorizonObservabilityPanel)
    },
    ...createHorizonErrorRoutes(),

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
